import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { OrdersScreen } from '@/features/orders/routes/orders-screen'

export const Route = createFileRoute('/orders')({ component: OrdersLayout })

function OrdersLayout() {
  // An order's page owns the whole screen; the list shows when none is open.
  const matches = useMatches()
  const hasChild = matches.some((match) => match.routeId === '/orders/$orderId')
  return hasChild ? <Outlet /> : <OrdersScreen />
}
